export interface PatientAddress {
  streetAddress1: string;
  streetAddress2?: string;
  city: string;
  stateCode: string;
  zip: string;
  countryCode: string;
}

export interface PatientCreditCard {
  id: string;
  number: string;
  type: string;
  expiry: string;
  isDefault: boolean;
}

export interface Pharmacy {
  pharmacyId: string;
  name: string;
  ncpdpId?: string;
  phone: string;
  address: PatientAddress;
  distanceMiles?: number;
}

export interface PatientProfile {
  createDateTimeUtc: string;
  address: PatientAddress;
  birthDate: string;
  creditAmount: number;
  email: string;
  firstName: string;
  gender: PatientGender;
  genderIdentity: string;
  hasMobileApp: boolean;
  hasTreatAccount: boolean;
  hasVisits: boolean;
  heightInches: number | null;
  identityVerification: {
    isCompleted: boolean;
    isLegacyCompleted: boolean;
    isCompletedWithErrors: boolean;
    remainingAttemptsCount: number;
    expireDate: string | null;
  };
  isStateRequireDrugScreen: boolean;
  imageUrl: string | null;
  lastName: string;
  maritalStatus: string;
  medicalRecordNumber: string;
  patientId: string;
  phoneNumber: PatientPhone;
  preferredName: string;
  racialBackground: string;
  referralCode: string | null;
  referralCreditAmount: number | null;
  unreadNotificationsCount: number;
  weightPounds: number | null;
  pharmacy: Pharmacy | null;
}

export enum PatientGender {
  FEMALE = 'female',
  MALE = 'male',
}

export interface PatientPhone {
  countryCode: string;
  number: string;
  prefix: string;
}

export interface SubscriptionEntitlement {
  patientSubscriptionEntitlementGlobalKey: string;
  remainingQuantity: number;
  price: number;
  validUntilDateTimeUtc: string | null;
}

export interface PatientSubscription {
  subscriptionId: number;
  patientSubscriptionGlobalKey: string;
  subscriptionGlobalKey: string;
  subscriptionName: string;
  price: number;
  recurringPaymentInterval: string;
  startDateUtc: string;
  endDateUtc: string | null;
  nextPaymentDateUtc: string;
  previousPaymentDateUtc: string;
  entitlements: SubscriptionEntitlement[];
}
